import React, { createContext, useContext, useMemo } from 'react';
import { Outlet, Navigate, useOutletContext } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Fiche People en contexte quand `MemberDetails` est rendu sous `/profile` (sans `Outlet` parent).
 * Fusionné avec le contexte `Outlet` de `/profile/edit` (édition membre).
 */
export const ProfileMemberOutletContext = createContext(null);

export function useProfileShellOutletMerged() {
  const fromOutlet = useOutletContext() || {};
  const fromBridge = useContext(ProfileMemberOutletContext) || {};
  return useMemo(() => ({ ...fromBridge, ...fromOutlet }), [fromBridge, fromOutlet]);
}

/** Enveloppe `/profile/edit` : fournit `profileMemberId` + `profileShell` pour `MemberEdit`. */
export function ProfileMemberShell() {
  const { user } = useAuth();
  const pid = String(user?.member_id || user?.person_id || '').trim();
  if (!pid) return <Navigate to="/profile" replace />;

  const ctx = { profileMemberId: pid, profileShell: 'membre' };

  return (
    <div className="min-h-[50vh] space-y-3 md:space-y-4">
      <Outlet context={ctx} />
    </div>
  );
}

/** Sous-section IAM : `/profile/compte` et `/profile/compte/modifier`. */
export function ProfileAccountShell() {
  const { user } = useAuth();
  const uid = String(user?.id || '').trim();
  if (!uid) return <Navigate to="/profile" replace />;

  const ctx = { profileUserId: uid, profileShell: 'compte' };

  return (
    <div className="min-h-[50vh] space-y-3 md:space-y-4">
      <Outlet context={ctx} />
    </div>
  );
}
